import * as React from 'react';
import classnames from 'classnames';

import styles from './styles.module.css';

export interface AboutOffendersProps {
  className?: string;
}

/**
 * @name AboutOffenders
 * @description A brief explanation of the how we look for and handle
 * "ingredient offenders" at Haldi.
 */
export const AboutOffenders = (props: AboutOffendersProps) => {
  const { className } = props;

  // Styles
  const cssComponent = classnames('bg-turmeric', styles.component, className);
  const cssHeading = classnames('about-heading', styles.heading);
  const cssReflow = classnames('flex flex-col', styles.reflow);

  return (
    <div className={cssComponent}>
      <div className="ui-container-lg">
        <h2 className={cssHeading}>
          <span className="block md:inline">
            We don’t care where you bought the product.
          </span>{' '}
          <span className="text-white">
            We’ll check for Ingredient Offenders.
            {/*
            <span className={styles.subhead}>
              (the trans fats of skincare).
            </span>
            */}
          </span>
        </h2>
        <div className={cssReflow}>
          <div className={styles.image}>
            <img alt="" src="/images/rebrand/offenders.png" />
          </div>
          <div className="flex-0 pt-8x">
            <p>
              We’ll always start by looking at your bathroom shelf, keeping
              what’s good—and if one of your products has any of our 8
              Ingredient Offenders, we help you find a replacement. We think of
              these 8 Ingredient Offenders as the “trans fats” of skincare.
              Ingredients that no one should be using. After all, it only takes
              one bad ingredient to mess up your routine.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
